export const selectVoucherTotal = state => state.customerInfo.data.voucherTotal;
export const selectPoints = state => state.customerInfo.data.points;
export const selectCardNr = state => state.customerInfo.data.cardNr;
export const selectCustomerInfo = state => state.customerInfo.data;
export const selectIsFetchingCustomerInfo = state =>
  state.customerInfo.isFetching;
export const selectHasCustomerInfo = state =>
  state.customerInfo.data.firstname !== '';
export const selectBadgeCount = state => state.customerInfo.data.badgeCount;
